import { addRoute } from "../shared/router.js";
import uber from "./page.vue";

addRoute("/uber", uber);
